<template>
  <div>
    <div class="culturalhistory">
      <div class="bannerbg" style="background:#3B8DE3" @click="handlevideoAction()">
        <!-- <img
            :src="row.cate_row.pic_url"
            class="bannerbg_pic"
        /> -->
        <div>
          <div class="bannerbg_desc" >
            <div class="bannerbg_desc_title">{{row.cate_row.name}}</div>
            <div class="bannerbg_desc_entitle">{{row.cate_row.s_name}}</div>
          </div>
        </div>
      </div>

      <div class="sai-list-title">
        <div class="container_wrap" >
          <div class="sai-list-row">
          <div class="sai-name">活动名称</div>
          <div class="sai-date">活动时间</div>
          <div class="sai-end">报名截止</div>
          <div class="sai-do">操作</div> 
          </div>
        </div>
      </div>

      <div class="container_wrap" >
        <div class="sai-list-wrap">
          <div class="sai-list-row" :key="i" v-for="(v,i) in row.list">
            <div class="sai-name">{{v.title}}</div>
            <div class="sai-date">{{v.jingwai_start_time}}</div>
            <div class="sai-end">{{v.jingwai_baoming_end}}</div>
            <div class="sai-do"  style="cursor:pointer" v-rblink="{ name: 'CmsDetail', query: { id: v.jingwai_tongzhi_id } }">
              <p>通知文件</p>
              </div> 
          </div> 
        </div>
 
  

  
 
      </div>
 

    </div>
  </div>
</template>
<script>
  import {formatDate} from "../../utils/date";
import SpecialTabs from "@/components/mainindex/SpecialTabs";
import ColumnTitle from "@/components/mainindex/ColumnTitle";

export default {
  name: "CulturalHistory",
  data() {
    return {
      videoAction: false,
      centerDialogVisible: false,
      tabList: [
        {name: "风采资讯", class: "tabs-item-active"},
        {name: "考级信息", class: ""},
        {name: "考级中心考级点", class: ""},
      ],

      cateList: [],
      personList: [],
      activeName: '',
      row: {
        cate_row: {},
        list: [], 
      }
 
    };
  },
  mounted() {
    document.title = "境外交流-活动列表"
    this.cate_id = this.$route.query.cate_id
    this.getNewsList() 
  },
  filters: {
    formatDate(time) {
      time = time * 1000;
      let date = new Date(time);
      return formatDate(date, " M-d ");
    },
  },
  components: {
    SpecialTabs, ColumnTitle
  },
  methods: {
 
    getNewsList(){
      const that = this;
      that.$api.get(
          "/api/cms/cmslist",
          {
            cate_id: that.cate_id,
          },
          (res) => {
            this.row = res.data; 
          },
      );
    },

    toDetail(id) {
      this.$router.push({path: "/cmsdetail", query: {id: id}});
    },

    onSelectType(item) {
      this.activeName = item.name
      this.getPersonList(item.id)
    },

    // 显示h5网页打开二维码
    onWhjDetail() {
      this.centerDialogVisible = true
    },

    //处理video点击事件
    handlevideoAction() {
      return
      this.videoAction = !this.videoAction;
      if (!this.videoAction && this.$refs.myVideo) {
        setTimeout(() => {
          this.$refs.myVideo.pause();
          this.$refs.myVideo.currentTime = 0;
        }, 600);
      }
    },

  },

};
</script>
<style lang="scss" scoped>

.sai-list-title{ 
  height: 60px;
  background: #3B8DE3; 
  .sai-list-row{  
    height: 60px;
    line-height: 60px;
    justify-content:space-between;  
    font-size: 16px; 
    font-weight: 500;
    color: #FFFFFF; 
}

}

.sai-list-row{ 
    display: flex;
    flex-wrap:wrap; 
    height: 98px;
    line-height: 98px;
    justify-content:space-between; 
    .sai-name{
      width: 480px;
      padding: 0 0 0 20px;
    }
    .sai-date{
      width: 150px;
      text-align: center;
    }
    .sai-end{
      width: 150px;
      text-align: center;
    }
    .sai-do{
      width: 150px;
      text-align: center;
    }
}

.container_wrap {
  width: 1200px;
  margin: 0 auto;
  .sai-list-wrap{
    .sai-list-row{
      p{
            width: 72px;
          height: 29px;
          margin-top: 37px;
          margin-left: 39px;
          line-height: 29px;
          background: linear-gradient(124deg, #FEC835 0%, #FFAD19 100%);
          border-radius: 77px;
          color: #fff;
      } 
    }

  .sai-list-row:nth-child(2n){
    background: #F5F5F5;
  } 
 }

}
 


.culturalhistory {
  background: #fff;
  //min-height: 1654px;
  padding-bottom: 30px;
}

.bannerbg {
  position: relative;
  height: 339px;
  overflow: hidden;

  .bannerbg_pic {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    height: 339px;
    object-fit: cover;
    width: 100%;
    display: block;
  }

  .bannerbg_desc {
    position: relative;
    z-index: 1;
    width: 1200px;
    margin: 0 auto;
    margin-top: 76px;
    padding-left: 40px;
    box-sizing: border-box;

    .bannerbg_desc_title {
      height: 70px;
      font-size: 50px;
      font-weight: 600;
      text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
      color: #ffffff;
      line-height: 70px;
    }

    .bannerbg_desc_entitle {
      height: 42px;
      font-size: 22px;
      // font-weight: 600;
      text-shadow: 0px 2px 4px rgba(0,0,0,0.5);
      color: #ffffff;
      line-height: 42px;
    }
  }

  .banner_videoplay_icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    width: 120px;
    height: 120px;
    object-fit: cover;

    &:hover {
      cursor: pointer;
      opacity: 0.9;
    }
  }

  video {
    height: 100%;
    width: 100%;
    object-fit: contain;
    // position: relative;
    // z-index: 0;
  }
}

.contactus_content {
  width: 1200px;
  min-height: 803px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 47px 103px 73px 36px;
  margin: 0 auto;

  .contactus_content_up {
    box-sizing: border-box;
    min-height: 558px;
  }

  .contactus_content_but {
    width: 260px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background: linear-gradient(124deg, #fec835 0%, #ffad19 100%);
    border-radius: 77px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: 400;
    color: #ffffff;

    &:hover {
      opacity: 0.89;
      cursor: pointer;
    }
  }
}

.tradeelite {
  //min-height: 1161px;
  background: #f8f8f8;
  overflow: hidden;
  padding-bottom: 30px;

  .header_screen {
    //height: 132px;
    //background: #ffffff;
    //box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 13px;
    padding: 0 15px;
    box-sizing: border-box;

    .header_screen_item {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      cursor: default;

      .header_screen_item_title {
        width: 30px;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-right: 41px;
      }

      .header_screen_item_els {
        flex: 1;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .header_screen_item_el {
          height: 36px;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 36px;
          //margin-right: 47px;
          //   margin-bottom: 23px;
          margin: 0 20px 10px 0;

          &:hover {
            cursor: pointer;
            color: #3B8DE3;
          }
        }

        .header_screen_item_el_active {
          //color: #f56057;
          font-weight: 500;
          padding: 0 10px;
          background: linear-gradient(130deg, #6BADF2 0%, #3B8DE3 100%);
          border-radius: 18px;
          color: #fff;
        }
      }
    }
  }

  .star_list {
    padding-top: 8px;
    box-sizing: border-box;
    // display: flex;
    // flex-direction: row;
    // flex-wrap: wrap;
    // justify-content: space-between;
    font-size: 0;

    .star_list_item_wrap {
      display: inline-block;
      margin-right: 30px;

      &:nth-child(3n) {
        margin-right: 0;
      }

      .star_list_item {
        // flex:25%;
        display: flex;
        flex-direction: row;
        width: 380px;
        height: 140px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
        border-radius: 16px;
        margin-top: 47px;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.03);
          cursor: pointer;
        }

        .star_list_item_pic {
          width: 119px;
          height: 146px;
          position: relative;
          margin: 0 24px 0 8px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            top: -15px;
            left: 0;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            overflow: hidden;
            background: pink;
          }
        }

        .star_list_item_right {
          display: flex;
          flex-direction: column;
          flex: 1;
          box-sizing: border-box;

          .star_list_item_right_name {
            max-width: 100%;
            height: 32px;
            font-size: 22px;
            font-weight: 500;
            color: #000000;
            line-height: 32px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-top: 16px;
          }

          .star_list_item_right_des {
            max-width: 100%;
            height: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #444444;
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 13px 0 7px 0;
          }

          .star_list_item_right_star {
            width: 88px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: linear-gradient(133deg, #fd9d00 0%, #fa6400 100%);
            border-radius: 10px 0px 10px 10px;
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// jingwaiZhou.vue?389abbba